<template>
  <div class="etc-applyBottom">
    <span @click="m_customService">客服中心</span>
    <div class="line" v-if="!noDetail"></div>
    <span @click="m_goPages('applyDetail')" v-if="!noDetail">办理详情</span>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'

export default {
  name: 'etc.applyBottom',
  mixins: [FunMixin],
  props: {
    noDetail: String
  },
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";

.etc-applyBottom {
  height: 110px;
  padding-top: 40px;
  padding-bottom: 30px;
  @extend %flex-center;
  font-size: 28px;
  color: #0094ee;
  .line{
    width: 2px;
    height: 28px;
    background-color: #dddddd;
    margin: 0 30px;
  }
}
</style>
